import type { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query'
import { createApi } from '@reduxjs/toolkit/query/react'

import { HTTP_METHODS } from 'common/constants/httpMethodsConstants'
import type { IOption } from 'common/interfaces/IOption'
import { UtilService } from 'common/services/utilService'
import { baseQuery } from 'common/store/api/fetchBaseQuery'
import { REDUCERS } from 'common/store/reducerConstants'

const { withPaginationParams } = UtilService

export const supportApi = createApi({
  reducerPath: REDUCERS.SUPPORT,
  baseQuery: baseQuery(),
  tagTypes: ['Support', 'Message'],
  endpoints: (build: EndpointBuilder<BaseQueryFn, string, string>) => ({
    fetchTickets: build.query({
      query: ({ siteId, tableParams }) => ({
        url: withPaginationParams('/support-tickets', tableParams),
        headers: { 'Database-Connection': siteId },
      }),
      providesTags: ['Support'],
    }),
    fetchTicketCategories: build.query({
      query: () => ({
        url: '/support-tickets/create',
      }),
      transformResponse: ({ categories }: { categories: IOption[] }): IOption[] => categories,
    }),
    createTicket: build.mutation({
      query: ({ ticket, siteId }) => ({
        data: ticket,
        url: '/support-tickets',
        method: HTTP_METHODS.POST,
        headers: { 'Database-Connection': siteId },
      }),
    }),
    fetchTicketDetails: build.query({
      query: ({ id, siteId }) => ({
        url: `/support-tickets/${id}`,
        headers: { 'Database-Connection': siteId },
      }),
      providesTags: ['Message'],
    }),
    addMessageOnTicket: build.mutation({
      query: ({ id, data, siteId }) => ({
        data: data,
        method: HTTP_METHODS.POST,
        url: `/support-tickets/${id}/add-message`,
        headers: { 'Database-Connection': siteId },
      }),
      invalidatesTags: ['Message'],
    }),
  }),
})

export const {
  useLazyFetchTicketsQuery,
  useCreateTicketMutation,
  useLazyFetchTicketCategoriesQuery,
  useAddMessageOnTicketMutation,
  useFetchTicketDetailsQuery,
  useLazyFetchTicketDetailsQuery,
}: any = supportApi
